
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue8 as ObiWindTrue8Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-8.js';
 
 
 

 
 export const ObiWindTrue8 = createComponent({
   react: React,
   tagName: 'obi-wind-true-8',
   elementClass: ObiWindTrue8Element,
   events: {
     
   }
  });
 
 